import React, { useEffect } from 'react';
import { Form, Select } from 'antd';
import FetchDataWrapper from '../../../../../../../components/FetchDataWrapper';
import { useFieldController } from '../../../../../../../helpers/formManager';
import styles from './index.module.scss';

const BaseSelectField = ({
  data,
  isFetching,
  refetch,
  fetchErrMsg,
  control,
  fieldSettings,
  initialValue,
  setIsFetchError,
}) => {
  const isError = data === 'Error';

  useEffect(() => {
    setIsFetchError(isError);
  }, [isError, setIsFetchError]);

  return (
    <FetchDataWrapper
      data={data}
      isFetching={isFetching}
      refetch={refetch}
      errMsg={fetchErrMsg}
    >
      <SelectField
        control={control}
        data={data}
        initialValue={initialValue}
        settings={fieldSettings}
        isFetching={isFetching}
      />
    </FetchDataWrapper>
  );
};

export default BaseSelectField;

function SelectField({ control, data, initialValue, settings, isFetching }) {
  const {
    field: { value, onChange },
    fieldState: { error } = {},
  } = useFieldController({
    control,
    name: settings.name,
    rules: { validate: createValidateFn(initialValue) },
  });

  return (
    <Form.Item
      label={settings.label}
      required
      validateStatus={error?.message ? 'error' : undefined}
      help={error?.message}
      className={styles.formItem}
      colon={false}
    >
      <Select
        value={isFetching ? undefined : value}
        onChange={onChange}
        placeholder="Выбрать из списка"
        style={{ width: '100%' }}
      >
        {data?.map((item) => (
          <Select.Option
            value={item.id}
            key={item.id}
            disabled={!item.available}
          >
            {item.name}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
}

function createValidateFn(initialValue) {
  return (value) => {
    if (value == null) {
      return 'Необходимо указать значение';
    }

    if (value === initialValue) {
      return 'Данные не изменены';
    }

    return true;
  };
}
